import React from 'react';
import PropTypes from 'prop-types';

import {green500, greyishBlue50, orange500, red600} from "assets/jss/main";

Bar.propTypes = {
    percentage: PropTypes.number.isRequired,
    height: PropTypes.number,
    color: PropTypes.string,
};

function Bar({percentage, height = 6, color = null}) {
    function getColor(pct) {
        if (pct < 50) return red600;
        if (pct < 75) return orange500;

        return green500;
    }

    if (!color) color = getColor(percentage);

    return (
        <div
            style={{
                flex: 1,
                borderRadius: "999px",
                backgroundColor: greyishBlue50,
                overflow: "hidden",
                minWidth: '64px'
            }}
        >
            <div
                style={{
                    width: `${percentage}%`,
                    height: `${height}px`,
                    backgroundColor: color,
                    borderRadius: "999px",
                }}
            />
        </div>
    );
}

export default Bar;
